<template>
  <div class="hello">

    <menupicker value="links">{{ active }}</menupicker>
    <h1>{{ msg }}</h1>

    <div id="contact-list" class="center green rcorners1">
      <table width="100%">
        <tr v-for="item in values ">
          <td width="35%">{{item.title}}</td>
          <td width="50%"><a v-bind:href="item.url" target="_blank">{{item.url}}</a></td>
        </tr>
      </table>
    </div>

  </div>

</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import MenuPicker from './MenuPicker.vue';
  import DynamoDb from 'aws-sdk/clients/dynamodb';

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

  export default {
    name: 'Links',
    data() {
      return {
        active: 'links',
        msg: 'Helpful Websites',
        values: [],
      }
    },
    methods: {
      loadData(awscredentials) {
        const docClient = new DynamoDb.DocumentClient({
          region: localStorage.getItem('region'),
          credentials: awscredentials,
        });

        const query = {
          TableName: 'links',
        }
        return new Promise((resolve, reject) => {
          docClient.scan(
            query,
            (error, data) => {
              if (error) {
                console.error('dynamodb error: ' + error.message);
                reject(`dynamodb error: ${error.message}`);
              }
              resolve(data);
            }
          )
        })
      },
      parseData(data) {
        this.values = [];
        for (let i = 0; i < data.Items.length; i++) {
          this.values[data.Items[i].id] = data.Items[i];
        }
      },
      initCredentials() {
        const credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: localStorage.getItem('poolid'),
        }, {region: localStorage.getItem('region')});
        return credentials;
      }
    },
    mounted() {
      this.loadData(this.initCredentials())
        .then(data => this.parseData(data));
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
    font-size: large;
  }

  ul .link {
    list-style-type: none;
    padding: 0;
  }

  li .link {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  td {
    text-align: left;
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    padding-bottom: 8px;
  }

  .bodycenter {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 100%;
    text-align: left;
  }

  .center {
    margin: auto;
    width: 90vw;
    padding: 10px;
  }

  .green {
    border: 3px solid green;
  }

  .normalli {
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Links.vue